import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl } from '../common/base.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent extends BaseCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.AUTH, locator, route);
  }

  ngOnInit() {
    this.changePassword();
  }

  public cpForm = {
    error: false,
    message: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    id: 0,
    inputerror: {}
  }

  changePassword() {
    var _self = this;

    if (this.cpForm.newPassword != this.cpForm.confirmPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'confirm Password is not matched';

    } else {
      let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.AUTH, "sso/cp/" + localStorage.getItem("skey"));

      this.locator.http.post(url, this.form.data, function (res, error) {

        if (error) {
          //alert("Server Error:" + error);
          console.log("--------------error------------->", error)
          return;
        }

        //console.log(res);
        _self.cpForm.message = '';
        _self.cpForm.inputerror = {};

        //console.log("1");
        _self.form.error = !res.success;
        if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
          _self.cpForm.message = res.result.message;
        }

        //console.log("2");
        if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
          _self.cpForm.inputerror = res.result.inputerror;
        }

        //console.log("3");

        if (_self.locator.dataValidator.isTrue(res.success)) {
          //console.log("4");
          console.log("res.result.data", res.result.data)
          _self.form.data = res.result.data;
          _self.cpForm.error = res.result.error;
          _self.cpForm.message = res.result.message;
          _self.cpForm.inputerror = res.result.inputerror;
          //console.log("1: userContext is set ", _self.locator.userContext);

        }
      });
    }
  }

}
